import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import Copy from '../Copy';

import { localizeAmount, getLiteralCurrency } from '../../commons/utils';

import '../../Animations.css';

const InfoAmount = (props) => {
  const { itsFree, colSize } = props;

  const labelData = (itsFree) ? 'discountOf' : 'importeTotalReserva';

  const showAmountInfo = () => {
    const { amount } = props;

    if (!amount || amount === '0') return false;

    return true;
  };

  const getAmountLabelData = () => {
    if (itsFree) return   <Copy of="percentage100" />;

    const { amount, currencyCode} = props;

    return `${localizeAmount(amount, currencyCode)} ${getLiteralCurrency(currencyCode)}`;
  };

  const getAmountPrintData = () => (
    <>
      <Col sm="12" className="title-label text-right">
        <Copy of={labelData} />
      </Col>
      <Col sm="12" className="price-label text-right">
        {getAmountLabelData()}
      </Col>
    </>
  );

  const getTemplate = () => {
    const { isVisible } = props;

    if (!isVisible) return <></>;

    return getAmountPrintData();
  };

  return (
    <Col sm={colSize} className="price-info align-self-end no-padding-right">
      <Row className="auto-margin justify-content-end">
        {(showAmountInfo()) && getTemplate()}
      </Row>
    </Col>
  );
};

InfoAmount.propTypes = {
  amount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  currencyCode: PropTypes.string,
  isVisible: PropTypes.bool,
  itsFree: PropTypes.bool,
  colSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

InfoAmount.defaultProps = {
  currencyCode: '',
  isVisible: true,
  itsFree: false,
  colSize: 12
};

export default InfoAmount;
